module.exports = __webpack_public_path__ + "img/malogo.1421de10.png";